import React from 'react';
import { Form, FormGroup, FormControl, Button, Row, Col } from 'react-bootstrap';
import { CustomDatePicker } from '../../_components';
import config from '../../../config';
import utils from '../../utils';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

const ROWS_PER_PAGE_OPTIONS = [10, 20, 30];
const DEFAULT_ROWS_PER_PAGE = 30;

class JobOrderSummaryReport extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: '99',
            jobNo: '',
            masterJobNo: '',
            reportRows: [],
            currentPage: 1,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            table: null,
            exportTable: null,
            loading: false,
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}</style>',
            tableHeader: '<table id="jobordersummaryreport" border=1; cellspacing=0/>'
                + '<tr>'
                + '<th style = "">Customer</th>'
                + '<th style = "">Customer PO</th>'
                + '<th style = "">Part No</th>'
                + '<th style = "">Part Description</th>'
                + '<th style = "">Job No</th>'
                + '<th style = "">Master Job No</th>'
                + '<th style = "">JS Qty</th>'
                + '<th style = "">Act Output (production)</th>'
                + '<th style = "">Reject Qty (production)</th>'
                + '<th style = "">Remaining Qty</th>'
                + '<th style = "">Planned Date</th>'
                + '<th style = "">Completed Date</th>'
                + '<th style = "">Machine/Line</th>'
                + '<th style = "">Status</th>'
                + '<th style = "">Remark</th>'
                + '</tr>'
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillMount() {
        this.setState({
            machines: []
        });
    }

    tdWrap(content) {
        return '<td>' + content + '</td>';
    }

    rowToHtml(job) {
        const jsQty = Number(job.jsQuantity) || 0;
        const actOutput = Number(job.total_output) || 0;
        const rejectQty = Number(job.total_reject) || 0;
        const remainingQty = job.remaining_qty != null
            ? Number(job.remaining_qty)
            : (jsQty - actOutput);
        const status = jsQty > 0 && jsQty <= actOutput ? 'closed' : 'open';

        let html = '<tr>';
        html += this.tdWrap(job.customer);
        html += this.tdWrap(job.po);
        html += this.tdWrap(job.partNo);
        html += this.tdWrap(job.partDesc);
        html += this.tdWrap(job.jobNo);
        html += this.tdWrap(job.masterJobNo || '');
        html += this.tdWrap(jsQty);
        html += this.tdWrap(actOutput);
        html += this.tdWrap(rejectQty);
        html += this.tdWrap(remainingQty);
        html += this.tdWrap(job.start);
        html += this.tdWrap(job.end);
        html += this.tdWrap(job.machineNo || job.lineNo);
        html += this.tdWrap(status);
        html += this.tdWrap(job.remark ? job.remark : '');
        html += '</tr>';
        return html;
    }

    rowsToTableHtml(rows) {
        const { tableStyle, tableHeader } = this.state;
        let html = '';
        (rows || []).forEach((job) => {
            html += this.rowToHtml(job);
        });
        return utils.sanitizeVoidTags((tableStyle + tableHeader + html.split('undefined').join(''))
            .replaceAll('</img>', '')
            .replaceAll('</input>', '')
            .replaceAll('</br>', '<br/>')
            .replaceAll('</hr>', '<hr/>'));
    }

    getTotalPages(rowsPerPage = this.state.rowsPerPage) {
        const total = this.state.reportRows.length;
        return Math.max(1, Math.ceil(total / rowsPerPage) || 1);
    }

    renderTablePage(page = this.state.currentPage, rowsPerPage = this.state.rowsPerPage) {
        const { reportRows } = this.state;
        const totalPages = this.getTotalPages(rowsPerPage);
        const safePage = Math.min(Math.max(1, page), totalPages);
        const start = (safePage - 1) * rowsPerPage;
        const pageRows = reportRows.slice(start, start + rowsPerPage);
        const table = this.rowsToTableHtml(pageRows);
        const exportTable = this.rowsToTableHtml(reportRows);
        this.setState({
            table,
            exportTable,
            currentPage: safePage,
            rowsPerPage,
        });
    }

    buildHtmlTable() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                status: this.state.status,
                start: this.state.selectedStart,
                end: this.state.selectedEnd,
                jobNo: this.state.jobNo,
                masterJobNo: this.state.masterJobNo
            })
        };

        if (localStorage.getItem('user') == null) {
            return Promise.resolve();
        }

        this.setState({ loading: true });

        return fetch(`${config.apiUrl}/getJobOrderSummaryReport?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
            .then((response) => response.text().then(text => (text ? JSON.parse(text) : [])))
            .then((body) => {
                const reportRows = Array.isArray(body) ? body : [];
                this.setState(
                    { reportRows, currentPage: 1, rowsPerPage: DEFAULT_ROWS_PER_PAGE, loading: false },
                    () => this.renderTablePage(1, DEFAULT_ROWS_PER_PAGE)
                );
                return reportRows;
            })
            .catch(() => {
                this.setState({ loading: false, reportRows: [], table: null, exportTable: null });
            });
    }

    handlePageChange = (page) => {
        this.renderTablePage(page, this.state.rowsPerPage);
    };

    handleRowsPerPageChange = (e) => {
        const rowsPerPage = Math.min(30, Math.max(10, parseInt(e.target.value, 10) || DEFAULT_ROWS_PER_PAGE));
        this.renderTablePage(1, rowsPerPage);
    };

    exportExcel() {
        const prevTable = this.state.table;
        const exportHtml = this.state.exportTable || this.rowsToTableHtml(this.state.reportRows);
        this.setState({ table: exportHtml }, () => {
            utils.tableToExcel('datatable', 'Report', 'JobOrderSummaryReport_' + this.state.jobNo + '.xls');
            this.setState({ table: prevTable });
        });
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    render() {
        const { table, status, jobNo, masterJobNo, reportRows, currentPage, rowsPerPage, loading } = this.state;
        const totalRows = reportRows.length;
        const totalPages = this.getTotalPages(rowsPerPage);
        const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
        const endRow = Math.min(currentPage * rowsPerPage, totalRows);

        return (
            <div className="container">
                <div style={{ marginBottom: '20px', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineExecution">
                            <Form.Label>Job Number</Form.Label>{' '}
                            <input className="form-control" name="jobNo" value={jobNo} onChange={this.handleChange} />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineExecution">
                            <Form.Label>Master Job Number</Form.Label>{' '}
                            <input className="form-control" name="masterJobNo" value={masterJobNo} onChange={this.handleChange} />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Status:</Form.Label>{' '}
                            <FormControl
                                as="select"
                                placeholder="select"
                                value={status === '99' || status === undefined ? 'select' : status}
                                onChange={(e) => {
                                    if (e.target.value !== 'select') {
                                        this.setState({ status: e.target.value });
                                    } else {
                                        this.setState({ status: '99' });
                                    }
                                }}
                            >
                                <option value="select">select</option>
                                <option key="1" value="1">Open</option>
                                <option key="2" value="2">Closed</option>
                            </FormControl>
                        </FormGroup>{' '}
                        <CustomDatePicker
                            label="Start"
                            controlId="formInlineStart"
                            value={this.state.selectedStart}
                            onChange={(value) => this.setState({ selectedStart: value })}
                        />{' '}
                        <CustomDatePicker
                            label="End"
                            controlId="formInlineEnd"
                            value={this.state.selectedEnd}
                            onChange={(value) => this.setState({ selectedEnd: value })}
                        />{' '}
                        <Button
                            variant="primary"
                            disabled={loading}
                            onClick={() => this.buildHtmlTable()}
                        >
                            {loading ? 'Loading...' : 'Show'}
                        </Button>
                        <DatacoLoadingIndicator loading={loading} label="Loading job order summary" />
                        {table ? (
                            <div style={{ width: '100%' }}>
                                <Button
                                    variant="primary"
                                    style={{ float: 'right', margin: 10 }}
                                    onClick={() => this.exportExcel()}
                                >
                                    Export
                                </Button>
                            </div>
                        ) : null}
                    </Form>
                    <a id="dlink" style={{ display: 'none' }} />
                </div>

                {table && totalRows > 0 ? (
                    <Row className="align-items-center mb-2" style={{ fontSize: '14px' }}>
                        <Col xs="auto">
                            <Form.Group className="mb-0 d-flex align-items-center gap-2">
                                <Form.Label className="mb-0">Rows per page</Form.Label>
                                <FormControl
                                    as="select"
                                    value={rowsPerPage}
                                    onChange={this.handleRowsPerPageChange}
                                    style={{ width: 'auto' }}
                                >
                                    {ROWS_PER_PAGE_OPTIONS.map((n) => (
                                        <option key={n} value={n}>{n}</option>
                                    ))}
                                </FormControl>
                            </Form.Group>
                        </Col>
                        <Col xs="auto">
                            Showing {startRow}–{endRow} of {totalRows}
                        </Col>
                        <Col xs="auto" className="ms-auto d-flex gap-2">
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={currentPage <= 1}
                                onClick={() => this.handlePageChange(currentPage - 1)}
                            >
                                Previous
                            </Button>
                            <span className="align-self-center">
                                Page {currentPage} of {totalPages}
                            </span>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={currentPage >= totalPages}
                                onClick={() => this.handlePageChange(currentPage + 1)}
                            >
                                Next
                            </Button>
                        </Col>
                    </Row>
                ) : null}

                <div
                    id="datatable"
                    className="container"
                    style={{ overflowY: 'auto' }}
                    dangerouslySetInnerHTML={{ __html: table }}
                />
            </div>
        );
    }
}

export { JobOrderSummaryReport };
